import { TypedDictionary } from '@core/utils/key-by';
import { Legend } from '@shared/legend';
import { Airport, CountryWithAirports, Region } from '@store/origins/types';
import { JbAutocompleteOptionsGroup } from 'jb-component-library/jb-autocomplete/types/jb-autocomplete-options-group';

import { CityPairSelector as CityPairSelectorContent } from '../../city-pair-selector/types/city-pair-selector.type';
import { CitySelectorType } from '../types/city-selector-type.enum';

export interface CitySelectorState {
  content: CityPairSelectorContent;
  showShortCityName: boolean;
  separatePartnerCities: boolean;
  airportSuggestions: CountryWithAirports[];
  allAirports: Airport[];
  citySelectorType: CitySelectorType;
  nearbyAirportCodes: string[];
  recentAirports: Airport[];
  originsFacadeAirports: Airport[];
  originsFacadeAirportsHashMap: TypedDictionary<Airport>;
  isMobile: boolean;
  // Dialog data below
  originsFacadeRegions: TypedDictionary<Region>;
  formWrapper: any;
  filterOutPartner: boolean;
  hideLegend: boolean;
  customLegendMessage: string;
  value: Airport;
  moveFocusToNextInput: boolean;
}

export interface CitySelectorViewModel {
  isMobile: boolean;
  modalLinkData: {
    label: string;
    shouldOpenDialog: boolean;
    url?: string;
  };
  allAirports: Airport[];
  groupedAirports: JbAutocompleteOptionsGroup[];
  label: string;
  isLegendShown: boolean;
  legends: TypedDictionary<Legend>;
  noMatchFoundCallback: (searchStr: string) => string;
}

export const citySelectorComponentInitialState: CitySelectorState = {
  content: undefined,
  showShortCityName: false,
  separatePartnerCities: false,
  airportSuggestions: [],
  allAirports: [],
  citySelectorType: CitySelectorType.ORIGIN,
  nearbyAirportCodes: [],
  recentAirports: [],
  originsFacadeAirports: [],
  originsFacadeAirportsHashMap: undefined,
  isMobile: false,
  originsFacadeRegions: undefined,
  formWrapper: undefined,
  filterOutPartner: false,
  hideLegend: false,
  customLegendMessage: '',
  value: null,
  moveFocusToNextInput: true,
};
